export default __webpack_public_path__ + "static/media/hinge4.d5a5d5eb.jpg";